import axios from 'axios';
import {getField, updateField} from 'vuex-map-fields';
// import { downloadFile } from "@/helpers/helpers";

const getDefaultState = () => {
    return {
        wholesalers: {
            items: [],
            from: 0,
            to: 0,
            total: 0
        },
        userOptions: [],
        totals: null,
        general: null,
        credit: null,
        invoicing: null,
        address: null,
        orders: null,
        history: null,
        wallet: null
    }
}

export const state = getDefaultState();

export const getters = {
    getField
}

export const actions = {
    async fetchWholesaler({commit}, pagination) {
        const response = await axios.post(`/fastmarket/admin/wholesaler?page=${pagination.currentPage}`, {...pagination});
        commit('SET_WHOLESALERS', response.data)
    },
    async fetchTotals({commit}) {
        const response = await axios.get(`/fastmarket/admin/wholesaler/totals`);
        commit('SET_TOTALS', response.data)
    },
    async fetchById({commit}, Id) {
        const response = await axios.get(`/fastmarket/admin/wholesaler/${Id}/show`);
        commit('SET_WHOLESALER', response.data.data);
    },
    async updateWholesaler({commit}, data){
        const response = await axios.put(`/fastmarket/admin/wholesaler`, data);
        commit('SET_WHOLESALER', response.data.user);
        return response.data.result
    },
    async fetchUsersSelect({ commit }, id) {
        const response = await axios.get(`/fastmarket/admin/wholesaler/${id}/userSelect`);
        commit('SET_USEROPTIONS', response.data);
    },
    /*eslint no-unused-vars: ["error", { "args": "none" }]*/
    async saveWallet({ commit, state }, data) {
        let toSend = { id: state.wallet.id, amount: data.value, description: data.reason }
        const response = await axios.post(`/fastmarket/admin/wholesaler/saveWallet`, toSend);
        return response.data.result
    },

}

export const mutations = {
    updateField,
    SET_WHOLESALERS: (state, result) => {
        state.wholesalers = {
            items: [],
            from: result.meta.from,
            to: result.meta.to,
            total: result.meta.total
        }
        let objectArray = Object.entries(result.data);

        objectArray.forEach(([key, value]) => {
            key;
            state.wholesalers.items.push(value)
        })
    },
    SET_TOTALS(state, result) {
        state.totals = result
    },
    SET_WHOLESALER(state, result) {
        state.general = {
            id: result.id,
            b2b_id: result.relationships.b2bUser.id,
            name: result.name,
            lastname: result.lastname,
            gender: result.relationships.b2bUser.customer.id_gender,
            email: result.email,
            phone: result.relationships.b2bUser.customer.phone,
            customer: {
                customer_id: result.relationships.b2bUser.customer.id_customer,
                email: result.relationships.b2bUser.customer.email,
            },
        }
        state.credit = {
            id: result.id,
            b2b_id: result.relationships.b2bUser.id,
            credit: result.relationships.b2bUser.credit,
            can_return: result.relationships.b2bUser.return,
            used_credit: result.relationships.b2bUser.used_credit,
            referred_by: result.relationships.b2bUser.referred_by,
            manufacturers: result.relationships.b2bUser.manufacturers,
        }
        state.invoicing = {
            id: result.id,
            b2b_id: result.relationships.b2bUser.id,
            customer_id: result.relationships.b2bUser.customer.id_customer,
            fiscal: !!result.relationships.b2bUser.rfc,
            rfc: result.relationships.b2bUser.rfc,
            razon_social: result.relationships.b2bUser.razon_social,
            cp_facturacion: result.relationships.b2bUser.cp_facturacion,
            regimen_fiscal: result.relationships.b2bUser.regimen_fiscal,
            uso_cfdi: result.relationships.b2bUser.uso_cfdi,
        }
        
        let exists = result.relationships.b2bUser.address ? true : false;
        state.address = {
            id: result.id,
            b2b_id: result.relationships.b2bUser.id,
            customer_id: result.relationships.b2bUser.customer.id_customer,
            id_address: exists ? result.relationships.b2bUser.address.id_address : null,
            firstname: exists ? result.relationships.b2bUser.address.firstname : null,
            lastname: exists ? result.relationships.b2bUser.address.lastname : null,
            address1: exists ? result.relationships.b2bUser.address.address1 : null,
            address2: exists ? result.relationships.b2bUser.address.address2 : null,
            company: exists ? result.relationships.b2bUser.address.company : null,
            postcode: exists ? result.relationships.b2bUser.address.postcode : null,
            city: exists ? result.relationships.b2bUser.address.city : null,
            id_country: exists ? result.relationships.b2bUser.address.id_country : null,
            id_state: exists ? result.relationships.b2bUser.address.id_state : null,
            phone: exists ? result.relationships.b2bUser.address.phone : null,
            other: exists ? result.relationships.b2bUser.address.other : null,
        }

        state.orders = {
            id: result.id,
            history: result.relationships.b2bUser.orders.data,
            total: result.relationships.b2bUser.total_bought,
        }

        state.payments = { 
            id: result.id,
            history: result.relationships.b2bUser.history.data,
            total: result.relationships.b2bUser.total_paid
        },

        state.wallet = {
            id: result.id,
            history: result.relationships.b2bUser.history_wallet,
            total: result.relationships.b2bUser.wallet,
        }
    },
    SET_USEROPTIONS(state, userOptions) {
        state.userOptions = userOptions;
    },
}